/* unplugin-vue-components disabled */import { render } from "./external-link.vue?vue&type=template&id=dba72c00"
import script from "./external-link.vue?vue&type=script&lang=js"
export * from "./external-link.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/md-content/external-link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dba72c00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dba72c00', __exports__)) {
    api.reload('dba72c00', __exports__)
  }
  
  module.hot.accept("./external-link.vue?vue&type=template&id=dba72c00", () => {
    api.rerender('dba72c00', render)
  })

}


export default __exports__